namespace SaAjaxUtils {
    /**
     * Be sure to also JSON.stringify the "data" field.
     */
    export const jsonSettings: JQuery.AjaxSettings = {
        contentType: "application/json; charset=utf-8",
        dataType: "json",
    };

    export function isJqXHR(obj: unknown): obj is JQuery.jqXHR {
        return (
            obj !== null &&
            typeof obj === "object" &&
            "abort" in obj &&
            "getAllResponseHeaders" in obj &&
            "done" in obj &&
            typeof obj.abort === "function" &&
            typeof obj.getAllResponseHeaders === "function" &&
            typeof obj.done === "function"
        );
    }
}

globalThis.SaAjaxUtils = SaAjaxUtils;
